// WRITTEN BY Claude Code (PLAI-8323)
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ActiveSessionService {
  hasValidToken(): boolean {
    if (environment.ENV_ACTIVE_PROFILE !== environment.ON_CUSTOMIDP) return false;
    const token = localStorage.getItem('access_token');
    if (!token) return false;
    const tokenSetTime = localStorage.getItem('token_set_time');
    const expiresIn = localStorage.getItem('expires_in');
    if (!tokenSetTime || !expiresIn) return true;
    const tokenAge = Math.floor(Date.now() / 1000) - parseInt(tokenSetTime, 10);
    return tokenAge < parseInt(expiresIn, 10) - 30;
  }

  // PLAI-11883: the portals share one origin once deployed, so they also share
  // one `localStorage`. The portal that owns the active token is the one whose
  // auth guard wrote `selected_role` after exchanging its authCode, so that key
  // tells us where to send the user back to. Not every guard writes it, so a page
  // that belongs to a single portal can pass a fallback role; the pages that front
  // several portals pass nothing and keep showing the login form rather than
  // guessing one.
  redirectToActiveSessionHome(fallbackRole?: string): boolean {
    const home = this.roleHome(localStorage.getItem('selected_role')) ?? this.roleHome(fallbackRole ?? null);
    if (!home) return false;
    window.location.replace(home);
    return true;
  }

  private roleHome(role: string | null): string | null {
    switch (role) {
      case 'N_GS':
      case 'SALESFORCE':
        return environment.SALESFORCE_AUTH?.salesforceRedirectUrl || null;
      case 'N_GU':
        return environment.SALESFORCE_AUTH?.underwritingRedirectUrl || null;
      case 'N_GA':
        return environment.SALESFORCE_AUTH?.adminPortalRedirectUrl || null;
      case 'N_HR':
      case 'N_ME':
        return this.employerPortalHome();
      default:
        return null;
    }
  }

  private employerPortalHome(): string | null {
    const base = environment.ON_CUSTOMIDP_Auth?.employerPortal;
    if (!base) return null;
    // Some envs configure employerPortal as the bare origin
    // (`https://host/CustomerPortal`), others include `/home` already
    // (`https://host/CustomerPortal/home`). Strip trailing slash + an
    // optional trailing `/home` so we don't produce `/home/home`.
    return base.replace(/\/+$/, '').replace(/\/home$/, '') + '/home';
  }
}
